<template>
  <OfferSimulationFeedbackDialogContainer
    :type="type"
    v-bind="$attrs"
    :reasons="cptdReasons"
    :tips="cptdTips"
    v-on="{
      close: onClose,
      'tip-click': onTipClick,
    }"
  >
    <template #title>
      No momento, você não está elegível para simular
    </template>
    <template #description>
      Isso pode ocorrer por diversos motivos, tais como:
    </template>
  </OfferSimulationFeedbackDialogContainer>
</template>
<script>
import { mapActions } from 'vuex'
import OfferSimulationFeedbackDialogContainer from '@/containers/loans/OfferSimulationFeedbackDialogContainer.vue'
import { JbClevertapEvent } from '~/data/clevertap/jb-clevertap'
export default {
  name: 'FgtsNoResultFeedbackDialogContainer',
  components: {
    OfferSimulationFeedbackDialogContainer,
  },
  props: {
    type: { type: String, default: 'warning' },
  },
  computed: {
    cptdReasons() {
      return [
        {
          title: 'Saldo insuficiente',
          description: 'Não ter saldo superior a R$ 300,00 disponível.',
        },
        {
          title: 'Modalidade de saque',
          description: 'Não optar pelo Saque-Aniversário FGTS.',
        },
        {
          title: 'Data de nascimento',
          description: 'A idade não atende os requisitos.',
        },
      ]
    },
    cptdTips() {
      return [
        {
          action: 'no-collateral',
          description: 'Simular sem garantia',
          path: '/forms/emprestimo/sem-garantia/simular',
        },
        {
          action: 'auto-equity',
          description: 'Simular com veículo em garantia',
          path: '/forms/emprestimo/auto/simular',
        },
        {
          action: 'home-equity',
          description: 'Simular com imóvel em garantia',
          path: '/forms/emprestimo/home-equity/simular',
        },
      ]
    },
  },
  mounted() {
    this.actEmitGaEvent({
      eventCategory: `fgts-simulation-no-results-modal`,
      eventAction: `view-modal`,
      eventLabel: `view-modal`,
    })
    this.actEmitInfobipModalDisplayedEvent({
      context: 'simulation_denied_feedback',
      product: 'fgts',
    })
    this.actCleverTapPushEvent({
      eventName: JbClevertapEvent.MODAL_DISPLAYED,
      eventData: {
        URL: location.pathname,
        Product: 'fgts',
        Context: 'simulation_denied_feedback',
      },
    })
  },
  methods: {
    ...mapActions({
      actEmitGaEvent: 'services/ga/actEmitGaEvent',
      actEmitInfobipModalDisplayedEvent:
        'services/events/actEmitInfobipModalDisplayedEvent',
      actCleverTapPushEvent: 'clevertap/actCleverTapPushEvent',
    }),
    onTipClick(tip) {
      this.actEmitGaEvent({
        eventCategory: `fgts-simulation-no-results-modal`,
        eventAction: `click-${tip.action}`,
        eventLabel: tip.description,
      })

      this.$router.push({ path: tip.path })
    },
    onClose() {
      this.actEmitGaEvent({
        eventCategory: `fgts-simulation-no-results-modal`,
        eventAction: `click-close`,
        eventLabel: `click-close`,
      })

      this.$router.push({ path: '/ofertas' })
    },
  },
}
</script>
<style lang="scss"></style>
